import api from 'apis/config/api-service';

interface Promotion {
  id?: string | number;
  [key: string]: any;
}

interface PromotionParams {
  [key: string]: any;
}

export default {
  getPromotions: (params?: PromotionParams) => api.get('promotions', { ...params }),
  getPromotionById: (id: string | number, params?: PromotionParams) => api.get(`promotions/${id}`, { ...params }),
  addOrUpdatePromotions: (data: Promotion) =>
    data.id ? api.patch(`promotions/${data.id}`, data) : api.post('promotions', data),
};
